import { Component, ViewEncapsulation, OnDestroy, HostBinding } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription, filter } from 'rxjs';

import { pageTransitions } from '../../animations/page-transitions';
import { ConnectionService } from '../../services/connection.service';
import { LoadingSpinnerComponent } from '../utils/loading-spinner.component';

@Component({
	selector: 'copo-redirect',
	templateUrl: './redirect.component.html',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [LoadingSpinnerComponent]
})
export class RedirectComponent implements OnDestroy {
	@HostBinding('class.fullscreen-content') componentClass = true;

	private readonly routerEventsSub: Subscription;
	constructor(
		private readonly connectionService: ConnectionService,
		private readonly router: Router
	) {
		this.routerEventsSub = router.events
			.pipe(filter(event => event instanceof NavigationEnd))
			.subscribe(async () => {
				const currentUrl = this.router.parseUrl(this.router.url);
				const error = currentUrl.queryParamMap.get('error');
				if (error) {
					console.error('error from authentification server', error, currentUrl.queryParams);
					return;
				}
				const path = currentUrl.queryParamMap.get('path');
				if (path) {
					await this.router.navigateByUrl(path, { replaceUrl: true });
					return;
				}
				const code = currentUrl.queryParamMap.get('code');
				const state = currentUrl.queryParamMap.get('state');

				if (!code || !state) {
					await this.router.navigateByUrl('/', { replaceUrl: true });
					return;
				}

				await this.connectionService.handleCode(code, state);
			});
	}

	ngOnDestroy() {
		this.routerEventsSub.unsubscribe();
	}
}
